import { safeMemoize } from '../utils/memoize.js';
const compute = ({ atom, selector }) => {
    const memoizedSelector = safeMemoize((value) => selector(value));
    const get = async () => {
        const values = await atom.get();
        return memoizedSelector(values);
    };
    const set = async () => {
        throw new Error('selected atom does not support set');
    };
    const observe = (callback) => {
        let prev;
        let called;
        return atom.observe(async (values) => {
            const selected = await memoizedSelector(values);
            if (called && prev === selected)
                return;
            called = true;
            prev = selected;
            return callback(selected);
        });
    };
    const computed = {
        ...atom,
        get,
        set,
        observe,
    };
    return computed;
};
export default compute;
